module.exports = __webpack_public_path__ + "img/program-kemoclub_2.ab5364ac.jpg";